import { render, staticRenderFns } from "./PPanelInputSelect.vue?vue&type=template&id=70fc18d6"
import script from "./PPanelInputSelect.vue?vue&type=script&lang=js"
export * from "./PPanelInputSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports